import { useState } from "react";
import Image from "next/image";
import styled from "@emotion/styled";
import { DialogModal } from "@ecologi/react-components";

const SRC = "/images/app/email-preview.jpg";
const ALT =
  "Preview of the recipient email — an Ecologi-branded gift notification with the impact summary and a link to the impact tile.";
// Match the intrinsic dimensions of /public/images/app/email-preview.jpg — update together if the asset changes.
const NATURAL_WIDTH = 1080;
const NATURAL_HEIGHT = 1300;
const THUMBNAIL_WIDTH = 240;

const ThumbnailButton = styled.button`
  all: unset;
  align-self: flex-start;
  display: inline-block;
  cursor: zoom-in;
  border: 1px solid ${({ theme }) => theme.colors.mist};
  border-radius: 8px;
  overflow: hidden;
  line-height: 0;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${({ theme }) => theme.colors.charcoal};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.charcoal};
    outline-offset: 2px;
  }
`;

const ThumbnailImage = styled(Image)`
  display: block;
  width: ${THUMBNAIL_WIDTH}px;
  height: auto;
  max-width: 100%;
`;

const ModalImage = styled(Image)`
  display: block;
  width: 100%;
  height: auto;
`;

export const EmailPreviewThumbnail = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ThumbnailButton
        type="button"
        aria-label="Open full email preview"
        onClick={() => setIsOpen(true)}
      >
        <ThumbnailImage
          src={SRC}
          alt={ALT}
          width={THUMBNAIL_WIDTH}
          height={Math.round(
            (THUMBNAIL_WIDTH / NATURAL_WIDTH) * NATURAL_HEIGHT
          )}
        />
      </ThumbnailButton>

      <DialogModal
        title="Email preview"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        scrollable
        dataTestId="email-preview-modal"
      >
        <ModalImage
          src={SRC}
          alt={ALT}
          width={NATURAL_WIDTH}
          height={NATURAL_HEIGHT}
        />
      </DialogModal>
    </>
  );
};
